import React from 'react'

//* Styles
import styles from './Button.module.scss';

const Button = ({ variant, handlers, children }) => {


    const variants = {
        "primary": styles["primary"],
        "secondary": styles["secondary"]
    }

  return (
    <div className={`${styles['btn']} ${variants[variant]}`}
        onClick={handlers.onClick}
    >{children}</div>
  )
}

export default Button